import React from 'react';
import CodingEditor from '../CodingEditor';

const QuestionRenderer = ({ question, value, onChange, onSubmitAnswer }) => {
  if (!question) {
    return <div>No question available.</div>;
  }

  if (question.type === 'mcq' && Array.isArray(question.options)) {
    return (
      <div className="question-block">
        <div className="question-text">{question.prompt}</div>
        <ul className="question-options">
          {question.options.map((option) => (
            <li key={option.value}>
              <label>
                <input
                  type="radio"
                  name={question.questionId}
                  value={option.value}
                  checked={value === option.value}
                  onChange={() => onChange(option.value)}
                />
                <span>{option.label}</span>
              </label>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  if (question.type === 'coding') {
    return (
      <div className="question-block">
        <CodingEditor
          question={question}
          value={value}
          onChange={onChange}
          onSubmit={onSubmitAnswer}
        />
      </div>
    );
  }

  return (
    <div className="question-block">
      <div className="question-text">{question.prompt}</div>
      <textarea
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
        rows={8}
        style={{ width: '100%' }}
        placeholder="Type your answer here"
      />
    </div>
  );
};

export default QuestionRenderer;
